// @flow

import React from "react";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import { withStyles } from "@material-ui/core/styles";
import { ColorSchema, WhiteText, BlackText, GreyText, InvalidText } from "../../global/types/scss";

type SingleTextFieldPropType = {
  isRequired?: boolean,
  label: string,
  name: string,
  value: string,
  className?: string,
  inputClass?: string,
  onChange: Function,
  inpuType: string,
  isInvalid?: boolean,
  isAutoFocus?: boolean,
  onBlur?: Function,
  onEnter?: Function
};

export const InputStyles = theme => ({
  textFieldUnderline: {
    "&:before": {
      borderBottomColor: ColorSchema("secondary"),
    },
    "&:hover:before": {
      borderBottomColor: GreyText + " !IMPORTANT",
    },
    "&:after": {
      borderBottomColor: ColorSchema("primary"),
    },
  },
  textFieldInput: {
    fontSize: "15px",
    paddingLeft: "20px",
    color: BlackText,
  },
  textFieldFormLabel: {
    color: ColorSchema("secondary"),
    paddingLeft: "30px",
    fontSize: "15px",
    "&$textFieldFormLabelFocused": {
      color: ColorSchema("primary"),
    },
  },
  textFieldFormLabelFocused: {},
  textUnderlineError: {
    "&:after":{
      borderBottomColor: InvalidText,
    },
  },
});

const SingleTextField = (props: SingleTextFieldPropType): * => {
  const classes = props.classes;
  return (
    <FormControl fullWidth={true}>
      {props.label !== "" &&
        <InputLabel
          htmlFor={props.name}
          required={props.isRequired}
          error={props.isInvalid}
          FormLabelClasses={{
            root: classes.textFieldFormLabel,
            focused: classes.textFieldFormLabelFocused,
          }}
        >
          {props.label}
        </InputLabel>
      }
      <Input
        id={props.name}
        name={props.name}
        value={props.value}
        className={props.className}
        error={props.isInvalid}
        classes={{
          underline: classes.textFieldUnderline,
          input: classes.textFieldInput + " " + (props.inputClass ? props.inputClass : ""),
          error: classes.textUnderlineError
        }}
        onChange={props.onChange}
        onBlur={props.onBlur}
        type={props.inpuType}
        fullWidth={true}
        inputProps={{ required: props.isRequired }}
        autoFocus={props.isAutoFocus}
        onKeyPress={(ev: Event) => {
          if (props.onEnter !== undefined) {
            if (ev.key === "Enter") {
              props.onEnter();
              ev.preventDefault();
            }
          }
        }}
      />
    </FormControl>
  );
};

export default withStyles(InputStyles)(SingleTextField);  


// WEBPACK FOOTER //
// ./src/global/components/SingleTextField.js